/**
 * Normalizes states API payloads across environments (data[], results[], Strapi attributes).
 */
export function normalizeStatesFromApi(payload) {
  if (!payload) return [];

  let raw = [];
  if (Array.isArray(payload)) {
    raw = payload;
  } else if (Array.isArray(payload.data)) {
    raw = payload.data;
  } else if (Array.isArray(payload.results)) {
    raw = payload.results;
  } else if (payload.data && Array.isArray(payload.data.results)) {
    raw = payload.data.results;
  }

  return raw
    .map((item) => {
      const attrs = item?.attributes ?? item ?? {};
      const id = item?.id ?? attrs?.id;
      const name =
        attrs?.name ??
        attrs?.state_name ??
        item?.name ??
        item?.state_name ??
        "";
      const abbreviation =
        attrs?.abbreviation ??
        attrs?.state_code ??
        item?.abbreviation ??
        item?.state_code ??
        (typeof name === "string" && name.length >= 2
          ? name.substring(0, 2).toUpperCase()
          : "");
      if (id == null || !String(name).trim()) return null;
      return {
        id,
        name: String(name).trim(),
        abbreviation,
        documentId: item?.documentId ?? attrs?.documentId,
        state_code: attrs?.state_code ?? item?.state_code,
      };
    })
    .filter(Boolean);
}

export const filterStateSelectOption = (option, rawInput) => {
  const query = String(rawInput || "")
    .trim()
    .toLowerCase();
  if (!query) return true;
  const label = String(option?.label ?? "").toLowerCase();
  const stateObject = option?.stateObject ?? option?.data?.stateObject;
  const abbr = String(stateObject?.abbreviation ?? "").toLowerCase();
  return label.includes(query) || abbr.includes(query);
};
